import React, { useEffect, useState } from 'react';
import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import { SyncProgressCompleteLayout } from "~/components/patientReports/SyncProgressCompleteLayout";
import { SyncProgressSectionLayout } from "~/components/patientReports/SyncProgressSectionLayout";
import Button from "@mui/material/Button";
import { CloseOutlined, SyncOutlined } from "@mui/icons-material";
export const SyncProgressLayout = (props) => {
    const { patientId, closeClicked, tryAgainClicked } = props;
    // Keep track of which progress bar to animate
    const [currentStep, setCurrentStep] = useState(1);
    const [connectingComplete, setConnectingComplete] = useState(false);
    const [checkingComplete, setCheckingComplete] = useState(false);
    const [downloadingComplete, setDownloadingComplete] = useState(false);
    const [autotextComplete, setAutotextComplete] = useState(false);
    const [billingComplete, setBillingComplete] = useState(false);
    const [connectingError, setConnectingError] = useState(false);
    const [checkingError, setCheckingError] = useState(false);
    const [downloadingError, setDownloadingError] = useState(false);
    const [autotextError, setAutotextError] = useState(false);
    const [billingError, setBillingError] = useState(false);
    const [showTryAgain, setShowTryAgain] = useState(false);
    useEffect(() => {
        // Runs only on the first render
        listenForProgress();
    }, []);
    function listenForProgress() {
        // @ts-ignore
        window.Pusher = Pusher;
        // console.log(Pusher.isReady);
        const echo = new Echo({
            broadcaster: 'pusher',
            key: 'a53aa42691c1c9e8e2f2',
            cluster: 'mt1',
            forceTLS: true,
            namespace: 'App.Services',
        });
        console.log('listening');
        echo.channel('messages' + patientId).listen('StreamingServices', (e) => {
            console.log('Got message 2!');
            console.log(e.message);
            if (e.message.includes('connecting')) {
                if (e.message.includes('connecting-error')) {
                    setConnectingError(true);
                    setShowTryAgain(true);
                    echo.channel('messages' + patientId).stopListening('StreamingServices');
                    echo.leaveAllChannels();
                }
            }
            if (e.message.includes('checking')) {
                setCurrentStep(2);
                setConnectingComplete(true);
                if (e.message.includes('checking-error')) {
                    setCheckingError(true);
                    setShowTryAgain(true);
                    echo.channel('messages' + patientId).stopListening('StreamingServices');
                    echo.leaveAllChannels();
                }
            }
            if (e.message.includes('downloading')) {
                setCurrentStep(3);
                setCheckingComplete(true);
                if (e.message.includes('downloading-error')) {
                    setDownloadingError(true);
                    setShowTryAgain(true);
                    echo.channel('messages' + patientId).stopListening('StreamingServices');
                    echo.leaveAllChannels();
                }
            }
            if (e.message.includes('autotext')) {
                setCurrentStep(4);
                setDownloadingComplete(true);
                if (e.message.includes('autotext-error')) {
                    setAutotextError(true);
                    // setShowTryAgain(true);
                    // echo.channel('messages'+patientId).stopListening('StreamingServices');
                    // echo.leaveAllChannels();
                }
            }
            if (e.message.includes('billing')) {
                setCurrentStep(5);
                setAutotextComplete(true);
                if (e.message.includes('billing-error')) {
                    setBillingError(true);
                    setShowTryAgain(true);
                    echo.channel('messages' + patientId).stopListening('StreamingServices');
                    echo.leaveAllChannels();
                }
            }
            if (e.message.includes('complete')) {
                setCurrentStep(6);
                setBillingComplete(true);
                echo.channel('messages' + patientId).stopListening('StreamingServices');
                echo.leaveAllChannels();
                sleep(1200);
                closeClicked();
            }
        });
        console.log(Pusher.isReady);
    }
    const resetValuesForTryAgain = () => {
        setCurrentStep(1);
        setConnectingComplete(false);
        setCheckingComplete(false);
        setDownloadingComplete(false);
        setAutotextComplete(false);
        setBillingComplete(false);
        setConnectingError(false);
        setCheckingError(false);
        setDownloadingError(false);
        setAutotextError(false);
        setBillingError(false);
        setShowTryAgain(false);
        tryAgainClicked();
        listenForProgress();
    };
    const sleep = ms => new Promise(r => setTimeout(r, ms));
    return (React.createElement("div", { style: { backgroundColor: 'white', width: 'fit-content', height: 'fit-content', paddingLeft: 39.15, paddingRight: 39.15, paddingTop: 25, paddingBottom: 25, borderRadius: 13.05, justifyContent: 'flex-start', display: 'inline-flex' } }, currentStep === 6 ?
        React.createElement(SyncProgressCompleteLayout, { closeClicked: closeClicked, isNoNewData: false, isError: false })
        :
            (React.createElement("div", null,
                showTryAgain &&
                    (React.createElement(React.Fragment, null,
                        React.createElement(CloseOutlined, { style: { float: 'right' }, onClick: closeClicked }),
                        React.createElement("br", null))),
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(SyncProgressSectionLayout, { sectionTitle: 'Connecting with server', loading: currentStep === 1, complete: connectingComplete, error: connectingError }),
                    React.createElement(SyncProgressSectionLayout, { sectionTitle: 'Checking for new data', loading: currentStep === 2, complete: checkingComplete, error: checkingError }),
                    React.createElement(SyncProgressSectionLayout, { sectionTitle: 'Grabbing most recent report', loading: currentStep === 3, complete: downloadingComplete, error: downloadingError }),
                    React.createElement(SyncProgressSectionLayout, { sectionTitle: 'Generating auto text', loading: currentStep === 4, complete: autotextComplete, error: autotextError }),
                    React.createElement(SyncProgressSectionLayout, { sectionTitle: 'Updating billing eligibility', loading: currentStep === 5, complete: billingComplete, error: billingError })),
                showTryAgain &&
                    React.createElement("div", { style: { width: '100%', textAlign: 'center' } },
                        React.createElement(Button, { style: { marginLeft: 'auto', marginRight: 'auto', backgroundColor: '#018FB7', color: '#FFFFFF' }, size: 'medium', startIcon: React.createElement(SyncOutlined, null), variant: 'contained', onClick: resetValuesForTryAgain }, "TRY AGAIN"))))));
};
